export default {
    "apiURL": "https://api.wtr-ent-app.jlp-ext.services/",
    //"apiURL": "https://api.wtr-ent-app.lfgbot.xyz/",
    //"apiURL": "http://192.168.0.108:4000/",
    //"apiURL": "http://localhost:4000/",
    "version": "1.4.6 (20241221.0)",
    "release": "PROD (SV 2.0.6)"
}